import { apiService } from "./apiService";
import { Productos, ProductoCatalogosDto } from "../dtos/Productos";
import { SyncProductosResponse } from "../dtos/SyncProductos";

export const productosService = {
  async getPagination(
    pageNumber = 1,
    pageSize = 50,
  ): Promise<Productos[]> {
    return apiService.getSecondary<Productos[]>(
      `/api/Productos/pagination?pageNumber=${pageNumber}&pageSize=${pageSize}`,
    );
  },

  async getByCodigo(codigo: number): Promise<Productos> {
    return apiService.get<Productos>(`/api/Productos/ByCodigo/${codigo}`);
  },

  async configurarCatalogos(
    codigo: number,
    dto: ProductoCatalogosDto,
  ): Promise<Productos> {
    return apiService.put<Productos, ProductoCatalogosDto>(
      `/api/Productos/${codigo}/catalogos`,
      dto,
    );
  },

  async searchByCodigo(codigo: string): Promise<Productos[]> {
    const term = codigo.trim();
    if (!term) return [];
    return apiService.getSecondary<Productos[]>(
      `/api/Productos/BuscarPorCodigo?codigo=${encodeURIComponent(term)}`,
    );
  },

  async getByDescripcion(descripcion: string): Promise<Productos[]> {
    const term = descripcion.trim();
    if (!term) return [];
    return apiService.getSecondary<Productos[]>(
      `/api/Productos/ByDescripcion/${encodeURIComponent(term)}`,
    );
  },

  async search(term: string): Promise<Productos[]> {
    const q = term.trim();
    if (!q) return [];

    if (/^\d+$/.test(q)) {
      try {
        const producto = await this.getByCodigo(Number(q));
        return producto ? [producto] : [];
      } catch {
        /* continúa con búsqueda por descripción */
      }
    }

    try {
      return await this.getByDescripcion(q);
    } catch {
      return [];
    }
  },

  async getSyncPanel(): Promise<Productos[]> {
    return apiService.get<Productos[]>("/api/Productos/sincronizacion/panel");
  },

  async syncProductos(): Promise<SyncProductosResponse> {
    return apiService.get<SyncProductosResponse>("/api/Sincronizacion/productos");
  },
};
